<template>
  <div class="orgsettlementsheet">
    <IndexHeader />
    <div class="settlementmiddle">
      <div>
        <p class="middleTxt">结算单</p>
      </div>
    </div>
    <table class="settlementInfo">
      <tr class="bg">
        <td class="leftFirst">课程名称</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.courseName }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>机构名称</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.organizationName }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>课程编号</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.courseId }}</span>
        </td>
        <td class="leftFirst">课程单价（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.money }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>开始时间</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.startTime }}</span>
        </td>
        <td class="leftFirst">结束时间</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.endTime }}</span>
        </td>
      </tr>
      <tr>
        <td class="bg">线上付款人数</td>
        <td colspan="2" class="bg">
          <span class="set_content">{{ data.detailData.onlineNum }}</span>
        </td>
        <td class="leftFirst bg">线上付款总额（元）</td>
        <td colspan="2" class="bg">
          <span class="set_content">{{ data.detailData.onlineMoney }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>线下付款人数</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.offineNum }}</span>
        </td>
        <td class="leftFirst">线下付款总额（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.offineMoney }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td class="color">总人数</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.allNum }}</span>
        </td>
        <td class="leftFirst color">总额（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.allMoney }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>分润率%</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.bonus }}%</span>
        </td>
        <td class="leftFirst">平台分润总额（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.bonusPlat }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>机构应收（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.organMoney }}</span>
        </td>
        <td class="leftFirst">机构应付（元）</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.organPay }}</span>
        </td>
      </tr>
      <tr>
        <td class="leftFirst maxHeight">缺勤人员名单</td>
        <td colspan="5">{{ data.detailData.absence }}</td>
      </tr>
      <tr>
        <td class="leftFirst bg"></td>
        <td colspan="5" class="title bg">发票信息</td>
      </tr>
      <tr class="bg">
        <td>名称</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.billName }}</span
          >
        </td>
      </tr>
      <tr class="bg">
        <td>发票类型</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.billType }}</span>
        </td>
        <td class="leftFirst">纳税人识别号</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.taxpayerNum }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>地址</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.billAddress }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>开户行</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.billBank }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>电话</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.billPhone }}</span>
        </td>
        <td class="leftFirst">账号</td>
        <td colspan="2">
          <span class="set_content">{{ data.detailData.billBankAccount }}</span>
        </td>
      </tr>
      <tr>
        <td class="bg"></td>
        <td colspan="5" class="title bg">结算账户</td>
      </tr>
      <tr class="bg">
        <td>账户名称</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.balanceAccount }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>开户行</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.balanceBank }}</span>
        </td>
      </tr>
      <tr class="bg">
        <td>账号</td>
        <td colspan="5">
          <span class="set_content">{{ data.detailData.balanceBankAccount }}</span>
        </td>
      </tr>
      <tr>
        <td class="maxHeight">备注</td>
        <td colspan="5">{{ data.detailData.remark }}</td>
      </tr>
    </table>
  </div>
</template>
<script setup>
import IndexHeader from "../../components/IndexHeader/TopBar";
import { ref, reactive } from "vue";
import { useRoute,useRouter } from "vue-router";
import { jsdDetail } from '../../server/jigou/course'

const route = useRoute()
const query =reactive({
  id: route.query.id,
})
const data = reactive({
  detailData:{}
})
async function getList(){
  let res = await jsdDetail(query)
  if( res != false ){
    data.detailData = res
  }
}
getList()

</script>
<style scoped>
.orgsettlementsheet {
  margin-top: 64px;
}
</style>